export const ROUTE_NAMES = {
  DASHBOARD: {
    SELF: 'dashboard',
    FAVORITES: 'favorites',
    MY_ORDERS: {
      SELF: 'orders',
      WITHDRAW: {
        INSURANCES: 'withdraw_insurances',
      },
    },
    MY_SALES: 'my_tradeins',
    KYC: {
      OTHER: 'dashboard_other',
      PROFILE: 'profile',
      DELETE_ACCOUNT: 'delete_account',
      REFER_FRIEND: 'refer_friend',
    },
    SERVICES_HUB: 'services_hub',
  },
}

export const MODAL_NAMES = {
  KYC: {
    PROFILE_PASSWORD_EDIT: 'profile_password_edit',
    PROFILE_INFO_EDIT: 'profile_info_edit',
    RIB_UPLOAD_MODAL: 'RIB_UPLOAD_MODAL',
    RIB_UPLOAD_CONFIRMATION_MODAL: 'RIB_UPLOAD_CONFIRMATION_MODAL',
    UNLINK_SOCIAL_ACCOUNTS_MODAL: 'UNLINK_SOCIAL_ACCOUNTS_MODAL',
  },
}

export const REGEXP_VALID_PASSWORD =
  /^((?=.*[a-z])(?=.*[A-Z])(?=.*[0-9]))[\s\S]{8,64}$/
